<div class="floating-popover" (click)="$event.stopPropagation()">
  @if (contentTemplate()) {
    <ng-container
      [ngTemplateOutlet]="contentTemplate()"
      [ngTemplateOutletContext]="contentContext() || {}"
    />
  }
</div>
